/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Appointment,
  AppointmentRequest,
  AppointmentType,
  AppointmentTypeRequest,
  AppointmentsHolidaysListParams,
  AppointmentsItemsListParams,
  AppointmentsTicketsListParams,
  AppointmentsTypesListParams,
  AppointmentsTypesSlotsListParams,
  BookRequest,
  CallRequest,
  CloseRequest,
  Holiday,
  HolidayRequest,
  PaginatedAppointmentList,
  PaginatedAppointmentTypeList,
  PaginatedHolidayList,
  PatchedAppointmentRequest,
  PatchedAppointmentTypeRequest,
  PatchedHolidayRequest,
  Slot,
  TakeTicketRequest,
  VisitTicket
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Closed days (N14): no slot and no automatic reminder.
 */
export type appointmentsHolidaysListResponse200 = {
  data: PaginatedHolidayList
  status: 200
}
    
export type appointmentsHolidaysListResponseSuccess = (appointmentsHolidaysListResponse200) & {
  headers: Headers;
};
;

export type appointmentsHolidaysListResponse = (appointmentsHolidaysListResponseSuccess)

export const getAppointmentsHolidaysListUrl = (params?: AppointmentsHolidaysListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/appointments/holidays/?${stringifiedParams}` : `/api/v1/appointments/holidays/`
}

export const appointmentsHolidaysList = async (params?: AppointmentsHolidaysListParams, options?: RequestInit): Promise<appointmentsHolidaysListResponse> => {
  
  return apiFetch<appointmentsHolidaysListResponse>(getAppointmentsHolidaysListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAppointmentsHolidaysListQueryKey = (params?: AppointmentsHolidaysListParams,) => {
    return [
    `/api/v1/appointments/holidays/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAppointmentsHolidaysListQueryOptions = <TData = Awaited<ReturnType<typeof appointmentsHolidaysList>>, TError = unknown>(params?: AppointmentsHolidaysListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsHolidaysList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppointmentsHolidaysListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appointmentsHolidaysList>>> = ({ signal }) => appointmentsHolidaysList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appointmentsHolidaysList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppointmentsHolidaysListQueryResult = NonNullable<Awaited<ReturnType<typeof appointmentsHolidaysList>>>
export type AppointmentsHolidaysListQueryError = unknown


export function useAppointmentsHolidaysList<TData = Awaited<ReturnType<typeof appointmentsHolidaysList>>, TError = unknown>(
 params: undefined |  AppointmentsHolidaysListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsHolidaysList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsHolidaysList>>,
          TError,
          Awaited<ReturnType<typeof appointmentsHolidaysList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsHolidaysList<TData = Awaited<ReturnType<typeof appointmentsHolidaysList>>, TError = unknown>(
 params?: AppointmentsHolidaysListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsHolidaysList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsHolidaysList>>,
          TError,
          Awaited<ReturnType<typeof appointmentsHolidaysList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsHolidaysList<TData = Awaited<ReturnType<typeof appointmentsHolidaysList>>, TError = unknown>(
 params?: AppointmentsHolidaysListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsHolidaysList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAppointmentsHolidaysList<TData = Awaited<ReturnType<typeof appointmentsHolidaysList>>, TError = unknown>(
 params?: AppointmentsHolidaysListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsHolidaysList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppointmentsHolidaysListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Closed days (N14): no slot and no automatic reminder.
 */
export type appointmentsHolidaysCreateResponse201 = {
  data: Holiday
  status: 201
}
    
export type appointmentsHolidaysCreateResponseSuccess = (appointmentsHolidaysCreateResponse201) & {
  headers: Headers;
};
;

export type appointmentsHolidaysCreateResponse = (appointmentsHolidaysCreateResponseSuccess)

export const getAppointmentsHolidaysCreateUrl = () => {


  

  return `/api/v1/appointments/holidays/`
}

export const appointmentsHolidaysCreate = async (holidayRequest: HolidayRequest, options?: RequestInit): Promise<appointmentsHolidaysCreateResponse> => {
  
  return apiFetch<appointmentsHolidaysCreateResponse>(getAppointmentsHolidaysCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      holidayRequest,)
  }
);}




export const getAppointmentsHolidaysCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsHolidaysCreate>>, TError,{data: HolidayRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsHolidaysCreate>>, TError,{data: HolidayRequest}, TContext> => {

const mutationKey = ['appointmentsHolidaysCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsHolidaysCreate>>, {data: HolidayRequest}> = (props) => {
          const {data} = props ?? {};

          return  appointmentsHolidaysCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsHolidaysCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsHolidaysCreate>>>
    export type AppointmentsHolidaysCreateMutationBody = HolidayRequest
    export type AppointmentsHolidaysCreateMutationError = unknown

    export const useAppointmentsHolidaysCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsHolidaysCreate>>, TError,{data: HolidayRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsHolidaysCreate>>,
        TError,
        {data: HolidayRequest},
        TContext
      > => {

      const mutationOptions = getAppointmentsHolidaysCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Closed days (N14): no slot and no automatic reminder.
 */
export type appointmentsHolidaysRetrieveResponse200 = {
  data: Holiday
  status: 200
}
    
export type appointmentsHolidaysRetrieveResponseSuccess = (appointmentsHolidaysRetrieveResponse200) & {
  headers: Headers;
};
;

export type appointmentsHolidaysRetrieveResponse = (appointmentsHolidaysRetrieveResponseSuccess)

export const getAppointmentsHolidaysRetrieveUrl = (id: string,) => {


  

  return `/api/v1/appointments/holidays/${id}/`
}

export const appointmentsHolidaysRetrieve = async (id: string, options?: RequestInit): Promise<appointmentsHolidaysRetrieveResponse> => {
  
  return apiFetch<appointmentsHolidaysRetrieveResponse>(getAppointmentsHolidaysRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAppointmentsHolidaysRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/appointments/holidays/${id}/`
    ] as const;
    }

    
export const getAppointmentsHolidaysRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppointmentsHolidaysRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>> = ({ signal }) => appointmentsHolidaysRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppointmentsHolidaysRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>>
export type AppointmentsHolidaysRetrieveQueryError = unknown


export function useAppointmentsHolidaysRetrieve<TData = Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>,
          TError,
          Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsHolidaysRetrieve<TData = Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>,
          TError,
          Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsHolidaysRetrieve<TData = Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAppointmentsHolidaysRetrieve<TData = Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsHolidaysRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppointmentsHolidaysRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Closed days (N14): no slot and no automatic reminder.
 */
export type appointmentsHolidaysUpdateResponse200 = {
  data: Holiday
  status: 200
}
    
export type appointmentsHolidaysUpdateResponseSuccess = (appointmentsHolidaysUpdateResponse200) & {
  headers: Headers;
};
;

export type appointmentsHolidaysUpdateResponse = (appointmentsHolidaysUpdateResponseSuccess)

export const getAppointmentsHolidaysUpdateUrl = (id: string,) => {


  

  return `/api/v1/appointments/holidays/${id}/`
}

export const appointmentsHolidaysUpdate = async (id: string,
    holidayRequest: HolidayRequest, options?: RequestInit): Promise<appointmentsHolidaysUpdateResponse> => {
  
  return apiFetch<appointmentsHolidaysUpdateResponse>(getAppointmentsHolidaysUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      holidayRequest,)
  }
);}




export const getAppointmentsHolidaysUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsHolidaysUpdate>>, TError,{id: string;data: HolidayRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsHolidaysUpdate>>, TError,{id: string;data: HolidayRequest}, TContext> => {

const mutationKey = ['appointmentsHolidaysUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsHolidaysUpdate>>, {id: string;data: HolidayRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  appointmentsHolidaysUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsHolidaysUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsHolidaysUpdate>>>
    export type AppointmentsHolidaysUpdateMutationBody = HolidayRequest
    export type AppointmentsHolidaysUpdateMutationError = unknown

    export const useAppointmentsHolidaysUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsHolidaysUpdate>>, TError,{id: string;data: HolidayRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsHolidaysUpdate>>,
        TError,
        {id: string;data: HolidayRequest},
        TContext
      > => {

      const mutationOptions = getAppointmentsHolidaysUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Closed days (N14): no slot and no automatic reminder.
 */
export type appointmentsHolidaysPartialUpdateResponse200 = {
  data: Holiday
  status: 200
}
    
export type appointmentsHolidaysPartialUpdateResponseSuccess = (appointmentsHolidaysPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type appointmentsHolidaysPartialUpdateResponse = (appointmentsHolidaysPartialUpdateResponseSuccess)

export const getAppointmentsHolidaysPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/appointments/holidays/${id}/`
}

export const appointmentsHolidaysPartialUpdate = async (id: string,
    patchedHolidayRequest: PatchedHolidayRequest, options?: RequestInit): Promise<appointmentsHolidaysPartialUpdateResponse> => {
  
  return apiFetch<appointmentsHolidaysPartialUpdateResponse>(getAppointmentsHolidaysPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedHolidayRequest,)
  }
);}




export const getAppointmentsHolidaysPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsHolidaysPartialUpdate>>, TError,{id: string;data: PatchedHolidayRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsHolidaysPartialUpdate>>, TError,{id: string;data: PatchedHolidayRequest}, TContext> => {

const mutationKey = ['appointmentsHolidaysPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsHolidaysPartialUpdate>>, {id: string;data: PatchedHolidayRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  appointmentsHolidaysPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsHolidaysPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsHolidaysPartialUpdate>>>
    export type AppointmentsHolidaysPartialUpdateMutationBody = PatchedHolidayRequest
    export type AppointmentsHolidaysPartialUpdateMutationError = unknown

    export const useAppointmentsHolidaysPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsHolidaysPartialUpdate>>, TError,{id: string;data: PatchedHolidayRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsHolidaysPartialUpdate>>,
        TError,
        {id: string;data: PatchedHolidayRequest},
        TContext
      > => {

      const mutationOptions = getAppointmentsHolidaysPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Closed days (N14): no slot and no automatic reminder.
 */
export type appointmentsHolidaysDestroyResponse204 = {
  data: void
  status: 204
}
    
export type appointmentsHolidaysDestroyResponseSuccess = (appointmentsHolidaysDestroyResponse204) & {
  headers: Headers;
};
;

export type appointmentsHolidaysDestroyResponse = (appointmentsHolidaysDestroyResponseSuccess)

export const getAppointmentsHolidaysDestroyUrl = (id: string,) => {


  

  return `/api/v1/appointments/holidays/${id}/`
}

export const appointmentsHolidaysDestroy = async (id: string, options?: RequestInit): Promise<appointmentsHolidaysDestroyResponse> => {
  
  return apiFetch<appointmentsHolidaysDestroyResponse>(getAppointmentsHolidaysDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getAppointmentsHolidaysDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsHolidaysDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsHolidaysDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['appointmentsHolidaysDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsHolidaysDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  appointmentsHolidaysDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsHolidaysDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsHolidaysDestroy>>>
    
    export type AppointmentsHolidaysDestroyMutationError = unknown

    export const useAppointmentsHolidaysDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsHolidaysDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsHolidaysDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAppointmentsHolidaysDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type appointmentsItemsListResponse200 = {
  data: PaginatedAppointmentList
  status: 200
}
    
export type appointmentsItemsListResponseSuccess = (appointmentsItemsListResponse200) & {
  headers: Headers;
};
;

export type appointmentsItemsListResponse = (appointmentsItemsListResponseSuccess)

export const getAppointmentsItemsListUrl = (params?: AppointmentsItemsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/appointments/items/?${stringifiedParams}` : `/api/v1/appointments/items/`
}

export const appointmentsItemsList = async (params?: AppointmentsItemsListParams, options?: RequestInit): Promise<appointmentsItemsListResponse> => {
  
  return apiFetch<appointmentsItemsListResponse>(getAppointmentsItemsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAppointmentsItemsListQueryKey = (params?: AppointmentsItemsListParams,) => {
    return [
    `/api/v1/appointments/items/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAppointmentsItemsListQueryOptions = <TData = Awaited<ReturnType<typeof appointmentsItemsList>>, TError = unknown>(params?: AppointmentsItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsItemsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppointmentsItemsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appointmentsItemsList>>> = ({ signal }) => appointmentsItemsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appointmentsItemsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppointmentsItemsListQueryResult = NonNullable<Awaited<ReturnType<typeof appointmentsItemsList>>>
export type AppointmentsItemsListQueryError = unknown


export function useAppointmentsItemsList<TData = Awaited<ReturnType<typeof appointmentsItemsList>>, TError = unknown>(
 params: undefined |  AppointmentsItemsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsItemsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsItemsList>>,
          TError,
          Awaited<ReturnType<typeof appointmentsItemsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsItemsList<TData = Awaited<ReturnType<typeof appointmentsItemsList>>, TError = unknown>(
 params?: AppointmentsItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsItemsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsItemsList>>,
          TError,
          Awaited<ReturnType<typeof appointmentsItemsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsItemsList<TData = Awaited<ReturnType<typeof appointmentsItemsList>>, TError = unknown>(
 params?: AppointmentsItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsItemsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAppointmentsItemsList<TData = Awaited<ReturnType<typeof appointmentsItemsList>>, TError = unknown>(
 params?: AppointmentsItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsItemsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppointmentsItemsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type appointmentsItemsRetrieveResponse200 = {
  data: Appointment
  status: 200
}
    
export type appointmentsItemsRetrieveResponseSuccess = (appointmentsItemsRetrieveResponse200) & {
  headers: Headers;
};
;

export type appointmentsItemsRetrieveResponse = (appointmentsItemsRetrieveResponseSuccess)

export const getAppointmentsItemsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/appointments/items/${id}/`
}

export const appointmentsItemsRetrieve = async (id: string, options?: RequestInit): Promise<appointmentsItemsRetrieveResponse> => {
  
  return apiFetch<appointmentsItemsRetrieveResponse>(getAppointmentsItemsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAppointmentsItemsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/appointments/items/${id}/`
    ] as const;
    }

    
export const getAppointmentsItemsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appointmentsItemsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsItemsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppointmentsItemsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appointmentsItemsRetrieve>>> = ({ signal }) => appointmentsItemsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appointmentsItemsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppointmentsItemsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appointmentsItemsRetrieve>>>
export type AppointmentsItemsRetrieveQueryError = unknown


export function useAppointmentsItemsRetrieve<TData = Awaited<ReturnType<typeof appointmentsItemsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsItemsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsItemsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof appointmentsItemsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsItemsRetrieve<TData = Awaited<ReturnType<typeof appointmentsItemsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsItemsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsItemsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof appointmentsItemsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsItemsRetrieve<TData = Awaited<ReturnType<typeof appointmentsItemsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsItemsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAppointmentsItemsRetrieve<TData = Awaited<ReturnType<typeof appointmentsItemsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsItemsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppointmentsItemsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type appointmentsItemsUpdateResponse200 = {
  data: Appointment
  status: 200
}
    
export type appointmentsItemsUpdateResponseSuccess = (appointmentsItemsUpdateResponse200) & {
  headers: Headers;
};
;

export type appointmentsItemsUpdateResponse = (appointmentsItemsUpdateResponseSuccess)

export const getAppointmentsItemsUpdateUrl = (id: string,) => {


  

  return `/api/v1/appointments/items/${id}/`
}

export const appointmentsItemsUpdate = async (id: string,
    appointmentRequest: AppointmentRequest, options?: RequestInit): Promise<appointmentsItemsUpdateResponse> => {
  
  return apiFetch<appointmentsItemsUpdateResponse>(getAppointmentsItemsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appointmentRequest,)
  }
);}




export const getAppointmentsItemsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsItemsUpdate>>, TError,{id: string;data: AppointmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsItemsUpdate>>, TError,{id: string;data: AppointmentRequest}, TContext> => {

const mutationKey = ['appointmentsItemsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsItemsUpdate>>, {id: string;data: AppointmentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  appointmentsItemsUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsItemsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsItemsUpdate>>>
    export type AppointmentsItemsUpdateMutationBody = AppointmentRequest
    export type AppointmentsItemsUpdateMutationError = unknown

    export const useAppointmentsItemsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsItemsUpdate>>, TError,{id: string;data: AppointmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsItemsUpdate>>,
        TError,
        {id: string;data: AppointmentRequest},
        TContext
      > => {

      const mutationOptions = getAppointmentsItemsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type appointmentsItemsPartialUpdateResponse200 = {
  data: Appointment
  status: 200
}
    
export type appointmentsItemsPartialUpdateResponseSuccess = (appointmentsItemsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type appointmentsItemsPartialUpdateResponse = (appointmentsItemsPartialUpdateResponseSuccess)

export const getAppointmentsItemsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/appointments/items/${id}/`
}

export const appointmentsItemsPartialUpdate = async (id: string,
    patchedAppointmentRequest: PatchedAppointmentRequest, options?: RequestInit): Promise<appointmentsItemsPartialUpdateResponse> => {
  
  return apiFetch<appointmentsItemsPartialUpdateResponse>(getAppointmentsItemsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedAppointmentRequest,)
  }
);}




export const getAppointmentsItemsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsItemsPartialUpdate>>, TError,{id: string;data: PatchedAppointmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsItemsPartialUpdate>>, TError,{id: string;data: PatchedAppointmentRequest}, TContext> => {

const mutationKey = ['appointmentsItemsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsItemsPartialUpdate>>, {id: string;data: PatchedAppointmentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  appointmentsItemsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsItemsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsItemsPartialUpdate>>>
    export type AppointmentsItemsPartialUpdateMutationBody = PatchedAppointmentRequest
    export type AppointmentsItemsPartialUpdateMutationError = unknown

    export const useAppointmentsItemsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsItemsPartialUpdate>>, TError,{id: string;data: PatchedAppointmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsItemsPartialUpdate>>,
        TError,
        {id: string;data: PatchedAppointmentRequest},
        TContext
      > => {

      const mutationOptions = getAppointmentsItemsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type appointmentsItemsCancelCreateResponse200 = {
  data: Appointment
  status: 200
}
    
export type appointmentsItemsCancelCreateResponseSuccess = (appointmentsItemsCancelCreateResponse200) & {
  headers: Headers;
};
;

export type appointmentsItemsCancelCreateResponse = (appointmentsItemsCancelCreateResponseSuccess)

export const getAppointmentsItemsCancelCreateUrl = (id: string,) => {


  

  return `/api/v1/appointments/items/${id}/cancel/`
}

export const appointmentsItemsCancelCreate = async (id: string, options?: RequestInit): Promise<appointmentsItemsCancelCreateResponse> => {
  
  return apiFetch<appointmentsItemsCancelCreateResponse>(getAppointmentsItemsCancelCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAppointmentsItemsCancelCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsItemsCancelCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsItemsCancelCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['appointmentsItemsCancelCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsItemsCancelCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  appointmentsItemsCancelCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsItemsCancelCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsItemsCancelCreate>>>
    
    export type AppointmentsItemsCancelCreateMutationError = unknown

    export const useAppointmentsItemsCancelCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsItemsCancelCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsItemsCancelCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAppointmentsItemsCancelCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type appointmentsItemsBookCreateResponse201 = {
  data: Appointment
  status: 201
}
    
export type appointmentsItemsBookCreateResponseSuccess = (appointmentsItemsBookCreateResponse201) & {
  headers: Headers;
};
;

export type appointmentsItemsBookCreateResponse = (appointmentsItemsBookCreateResponseSuccess)

export const getAppointmentsItemsBookCreateUrl = () => {


  

  return `/api/v1/appointments/items/book/`
}

export const appointmentsItemsBookCreate = async (bookRequest: BookRequest, options?: RequestInit): Promise<appointmentsItemsBookCreateResponse> => {
  
  return apiFetch<appointmentsItemsBookCreateResponse>(getAppointmentsItemsBookCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bookRequest,)
  }
);}




export const getAppointmentsItemsBookCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsItemsBookCreate>>, TError,{data: BookRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsItemsBookCreate>>, TError,{data: BookRequest}, TContext> => {

const mutationKey = ['appointmentsItemsBookCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsItemsBookCreate>>, {data: BookRequest}> = (props) => {
          const {data} = props ?? {};

          return  appointmentsItemsBookCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsItemsBookCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsItemsBookCreate>>>
    export type AppointmentsItemsBookCreateMutationBody = BookRequest
    export type AppointmentsItemsBookCreateMutationError = unknown

    export const useAppointmentsItemsBookCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsItemsBookCreate>>, TError,{data: BookRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsItemsBookCreate>>,
        TError,
        {data: BookRequest},
        TContext
      > => {

      const mutationOptions = getAppointmentsItemsBookCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * N8: walk-in reception queue of the day (the reception tablet and the Pro app).
 */
export type appointmentsTicketsListResponse200 = {
  data: VisitTicket[]
  status: 200
}
    
export type appointmentsTicketsListResponseSuccess = (appointmentsTicketsListResponse200) & {
  headers: Headers;
};
;

export type appointmentsTicketsListResponse = (appointmentsTicketsListResponseSuccess)

export const getAppointmentsTicketsListUrl = (params?: AppointmentsTicketsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/appointments/tickets/?${stringifiedParams}` : `/api/v1/appointments/tickets/`
}

export const appointmentsTicketsList = async (params?: AppointmentsTicketsListParams, options?: RequestInit): Promise<appointmentsTicketsListResponse> => {
  
  return apiFetch<appointmentsTicketsListResponse>(getAppointmentsTicketsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAppointmentsTicketsListQueryKey = (params?: AppointmentsTicketsListParams,) => {
    return [
    `/api/v1/appointments/tickets/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAppointmentsTicketsListQueryOptions = <TData = Awaited<ReturnType<typeof appointmentsTicketsList>>, TError = unknown>(params?: AppointmentsTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppointmentsTicketsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appointmentsTicketsList>>> = ({ signal }) => appointmentsTicketsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appointmentsTicketsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppointmentsTicketsListQueryResult = NonNullable<Awaited<ReturnType<typeof appointmentsTicketsList>>>
export type AppointmentsTicketsListQueryError = unknown


export function useAppointmentsTicketsList<TData = Awaited<ReturnType<typeof appointmentsTicketsList>>, TError = unknown>(
 params: undefined |  AppointmentsTicketsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTicketsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsTicketsList>>,
          TError,
          Awaited<ReturnType<typeof appointmentsTicketsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsTicketsList<TData = Awaited<ReturnType<typeof appointmentsTicketsList>>, TError = unknown>(
 params?: AppointmentsTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTicketsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsTicketsList>>,
          TError,
          Awaited<ReturnType<typeof appointmentsTicketsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsTicketsList<TData = Awaited<ReturnType<typeof appointmentsTicketsList>>, TError = unknown>(
 params?: AppointmentsTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAppointmentsTicketsList<TData = Awaited<ReturnType<typeof appointmentsTicketsList>>, TError = unknown>(
 params?: AppointmentsTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppointmentsTicketsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * N8: walk-in reception queue of the day (the reception tablet and the Pro app).
 */
export type appointmentsTicketsCreateResponse201 = {
  data: VisitTicket
  status: 201
}
    
export type appointmentsTicketsCreateResponseSuccess = (appointmentsTicketsCreateResponse201) & {
  headers: Headers;
};
;

export type appointmentsTicketsCreateResponse = (appointmentsTicketsCreateResponseSuccess)

export const getAppointmentsTicketsCreateUrl = () => {


  

  return `/api/v1/appointments/tickets/`
}

export const appointmentsTicketsCreate = async (takeTicketRequest: TakeTicketRequest, options?: RequestInit): Promise<appointmentsTicketsCreateResponse> => {
  
  return apiFetch<appointmentsTicketsCreateResponse>(getAppointmentsTicketsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      takeTicketRequest,)
  }
);}




export const getAppointmentsTicketsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsTicketsCreate>>, TError,{data: TakeTicketRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsTicketsCreate>>, TError,{data: TakeTicketRequest}, TContext> => {

const mutationKey = ['appointmentsTicketsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsTicketsCreate>>, {data: TakeTicketRequest}> = (props) => {
          const {data} = props ?? {};

          return  appointmentsTicketsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsTicketsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsTicketsCreate>>>
    export type AppointmentsTicketsCreateMutationBody = TakeTicketRequest
    export type AppointmentsTicketsCreateMutationError = unknown

    export const useAppointmentsTicketsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsTicketsCreate>>, TError,{data: TakeTicketRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsTicketsCreate>>,
        TError,
        {data: TakeTicketRequest},
        TContext
      > => {

      const mutationOptions = getAppointmentsTicketsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * N8: walk-in reception queue of the day (the reception tablet and the Pro app).
 */
export type appointmentsTicketsRetrieveResponse200 = {
  data: VisitTicket
  status: 200
}
    
export type appointmentsTicketsRetrieveResponseSuccess = (appointmentsTicketsRetrieveResponse200) & {
  headers: Headers;
};
;

export type appointmentsTicketsRetrieveResponse = (appointmentsTicketsRetrieveResponseSuccess)

export const getAppointmentsTicketsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/appointments/tickets/${id}/`
}

export const appointmentsTicketsRetrieve = async (id: string, options?: RequestInit): Promise<appointmentsTicketsRetrieveResponse> => {
  
  return apiFetch<appointmentsTicketsRetrieveResponse>(getAppointmentsTicketsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAppointmentsTicketsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/appointments/tickets/${id}/`
    ] as const;
    }

    
export const getAppointmentsTicketsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppointmentsTicketsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>> = ({ signal }) => appointmentsTicketsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppointmentsTicketsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>>
export type AppointmentsTicketsRetrieveQueryError = unknown


export function useAppointmentsTicketsRetrieve<TData = Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsTicketsRetrieve<TData = Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsTicketsRetrieve<TData = Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAppointmentsTicketsRetrieve<TData = Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppointmentsTicketsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * N8: walk-in reception queue of the day (the reception tablet and the Pro app).
 */
export type appointmentsTicketsCallCreateResponse200 = {
  data: VisitTicket
  status: 200
}
    
export type appointmentsTicketsCallCreateResponseSuccess = (appointmentsTicketsCallCreateResponse200) & {
  headers: Headers;
};
;

export type appointmentsTicketsCallCreateResponse = (appointmentsTicketsCallCreateResponseSuccess)

export const getAppointmentsTicketsCallCreateUrl = (id: string,) => {


  

  return `/api/v1/appointments/tickets/${id}/call/`
}

export const appointmentsTicketsCallCreate = async (id: string,
    callRequest: CallRequest, options?: RequestInit): Promise<appointmentsTicketsCallCreateResponse> => {
  
  return apiFetch<appointmentsTicketsCallCreateResponse>(getAppointmentsTicketsCallCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      callRequest,)
  }
);}




export const getAppointmentsTicketsCallCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsTicketsCallCreate>>, TError,{id: string;data: CallRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsTicketsCallCreate>>, TError,{id: string;data: CallRequest}, TContext> => {

const mutationKey = ['appointmentsTicketsCallCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsTicketsCallCreate>>, {id: string;data: CallRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  appointmentsTicketsCallCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsTicketsCallCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsTicketsCallCreate>>>
    export type AppointmentsTicketsCallCreateMutationBody = CallRequest
    export type AppointmentsTicketsCallCreateMutationError = unknown

    export const useAppointmentsTicketsCallCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsTicketsCallCreate>>, TError,{id: string;data: CallRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsTicketsCallCreate>>,
        TError,
        {id: string;data: CallRequest},
        TContext
      > => {

      const mutationOptions = getAppointmentsTicketsCallCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * N8: walk-in reception queue of the day (the reception tablet and the Pro app).
 */
export type appointmentsTicketsCloseCreateResponse200 = {
  data: VisitTicket
  status: 200
}
    
export type appointmentsTicketsCloseCreateResponseSuccess = (appointmentsTicketsCloseCreateResponse200) & {
  headers: Headers;
};
;

export type appointmentsTicketsCloseCreateResponse = (appointmentsTicketsCloseCreateResponseSuccess)

export const getAppointmentsTicketsCloseCreateUrl = (id: string,) => {


  

  return `/api/v1/appointments/tickets/${id}/close/`
}

export const appointmentsTicketsCloseCreate = async (id: string,
    closeRequest: CloseRequest, options?: RequestInit): Promise<appointmentsTicketsCloseCreateResponse> => {
  
  return apiFetch<appointmentsTicketsCloseCreateResponse>(getAppointmentsTicketsCloseCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      closeRequest,)
  }
);}




export const getAppointmentsTicketsCloseCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsTicketsCloseCreate>>, TError,{id: string;data: CloseRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsTicketsCloseCreate>>, TError,{id: string;data: CloseRequest}, TContext> => {

const mutationKey = ['appointmentsTicketsCloseCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsTicketsCloseCreate>>, {id: string;data: CloseRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  appointmentsTicketsCloseCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsTicketsCloseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsTicketsCloseCreate>>>
    export type AppointmentsTicketsCloseCreateMutationBody = CloseRequest
    export type AppointmentsTicketsCloseCreateMutationError = unknown

    export const useAppointmentsTicketsCloseCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsTicketsCloseCreate>>, TError,{id: string;data: CloseRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsTicketsCloseCreate>>,
        TError,
        {id: string;data: CloseRequest},
        TContext
      > => {

      const mutationOptions = getAppointmentsTicketsCloseCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * N8: walk-in reception queue of the day (the reception tablet and the Pro app).
 */
export type appointmentsTicketsCallNextCreateResponse200 = {
  data: VisitTicket
  status: 200
}

export type appointmentsTicketsCallNextCreateResponse204 = {
  data: void
  status: 204
}
    
export type appointmentsTicketsCallNextCreateResponseSuccess = (appointmentsTicketsCallNextCreateResponse200 | appointmentsTicketsCallNextCreateResponse204) & {
  headers: Headers;
};
;

export type appointmentsTicketsCallNextCreateResponse = (appointmentsTicketsCallNextCreateResponseSuccess)

export const getAppointmentsTicketsCallNextCreateUrl = () => {


  

  return `/api/v1/appointments/tickets/call_next/`
}

export const appointmentsTicketsCallNextCreate = async (callRequest: CallRequest, options?: RequestInit): Promise<appointmentsTicketsCallNextCreateResponse> => {
  
  return apiFetch<appointmentsTicketsCallNextCreateResponse>(getAppointmentsTicketsCallNextCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      callRequest,)
  }
);}




export const getAppointmentsTicketsCallNextCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsTicketsCallNextCreate>>, TError,{data: CallRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsTicketsCallNextCreate>>, TError,{data: CallRequest}, TContext> => {

const mutationKey = ['appointmentsTicketsCallNextCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsTicketsCallNextCreate>>, {data: CallRequest}> = (props) => {
          const {data} = props ?? {};

          return  appointmentsTicketsCallNextCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsTicketsCallNextCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsTicketsCallNextCreate>>>
    export type AppointmentsTicketsCallNextCreateMutationBody = CallRequest
    export type AppointmentsTicketsCallNextCreateMutationError = unknown

    export const useAppointmentsTicketsCallNextCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsTicketsCallNextCreate>>, TError,{data: CallRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsTicketsCallNextCreate>>,
        TError,
        {data: CallRequest},
        TContext
      > => {

      const mutationOptions = getAppointmentsTicketsCallNextCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type appointmentsTypesListResponse200 = {
  data: PaginatedAppointmentTypeList
  status: 200
}
    
export type appointmentsTypesListResponseSuccess = (appointmentsTypesListResponse200) & {
  headers: Headers;
};
;

export type appointmentsTypesListResponse = (appointmentsTypesListResponseSuccess)

export const getAppointmentsTypesListUrl = (params?: AppointmentsTypesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/appointments/types/?${stringifiedParams}` : `/api/v1/appointments/types/`
}

export const appointmentsTypesList = async (params?: AppointmentsTypesListParams, options?: RequestInit): Promise<appointmentsTypesListResponse> => {
  
  return apiFetch<appointmentsTypesListResponse>(getAppointmentsTypesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAppointmentsTypesListQueryKey = (params?: AppointmentsTypesListParams,) => {
    return [
    `/api/v1/appointments/types/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAppointmentsTypesListQueryOptions = <TData = Awaited<ReturnType<typeof appointmentsTypesList>>, TError = unknown>(params?: AppointmentsTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppointmentsTypesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appointmentsTypesList>>> = ({ signal }) => appointmentsTypesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppointmentsTypesListQueryResult = NonNullable<Awaited<ReturnType<typeof appointmentsTypesList>>>
export type AppointmentsTypesListQueryError = unknown


export function useAppointmentsTypesList<TData = Awaited<ReturnType<typeof appointmentsTypesList>>, TError = unknown>(
 params: undefined |  AppointmentsTypesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsTypesList>>,
          TError,
          Awaited<ReturnType<typeof appointmentsTypesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsTypesList<TData = Awaited<ReturnType<typeof appointmentsTypesList>>, TError = unknown>(
 params?: AppointmentsTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsTypesList>>,
          TError,
          Awaited<ReturnType<typeof appointmentsTypesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsTypesList<TData = Awaited<ReturnType<typeof appointmentsTypesList>>, TError = unknown>(
 params?: AppointmentsTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAppointmentsTypesList<TData = Awaited<ReturnType<typeof appointmentsTypesList>>, TError = unknown>(
 params?: AppointmentsTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppointmentsTypesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type appointmentsTypesCreateResponse201 = {
  data: AppointmentType
  status: 201
}
    
export type appointmentsTypesCreateResponseSuccess = (appointmentsTypesCreateResponse201) & {
  headers: Headers;
};
;

export type appointmentsTypesCreateResponse = (appointmentsTypesCreateResponseSuccess)

export const getAppointmentsTypesCreateUrl = () => {


  

  return `/api/v1/appointments/types/`
}

export const appointmentsTypesCreate = async (appointmentTypeRequest: AppointmentTypeRequest, options?: RequestInit): Promise<appointmentsTypesCreateResponse> => {
  
  return apiFetch<appointmentsTypesCreateResponse>(getAppointmentsTypesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appointmentTypeRequest,)
  }
);}




export const getAppointmentsTypesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsTypesCreate>>, TError,{data: AppointmentTypeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsTypesCreate>>, TError,{data: AppointmentTypeRequest}, TContext> => {

const mutationKey = ['appointmentsTypesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsTypesCreate>>, {data: AppointmentTypeRequest}> = (props) => {
          const {data} = props ?? {};

          return  appointmentsTypesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsTypesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsTypesCreate>>>
    export type AppointmentsTypesCreateMutationBody = AppointmentTypeRequest
    export type AppointmentsTypesCreateMutationError = unknown

    export const useAppointmentsTypesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsTypesCreate>>, TError,{data: AppointmentTypeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsTypesCreate>>,
        TError,
        {data: AppointmentTypeRequest},
        TContext
      > => {

      const mutationOptions = getAppointmentsTypesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type appointmentsTypesRetrieveResponse200 = {
  data: AppointmentType
  status: 200
}
    
export type appointmentsTypesRetrieveResponseSuccess = (appointmentsTypesRetrieveResponse200) & {
  headers: Headers;
};
;

export type appointmentsTypesRetrieveResponse = (appointmentsTypesRetrieveResponseSuccess)

export const getAppointmentsTypesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/appointments/types/${id}/`
}

export const appointmentsTypesRetrieve = async (id: string, options?: RequestInit): Promise<appointmentsTypesRetrieveResponse> => {
  
  return apiFetch<appointmentsTypesRetrieveResponse>(getAppointmentsTypesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAppointmentsTypesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/appointments/types/${id}/`
    ] as const;
    }

    
export const getAppointmentsTypesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof appointmentsTypesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppointmentsTypesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appointmentsTypesRetrieve>>> = ({ signal }) => appointmentsTypesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppointmentsTypesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof appointmentsTypesRetrieve>>>
export type AppointmentsTypesRetrieveQueryError = unknown


export function useAppointmentsTypesRetrieve<TData = Awaited<ReturnType<typeof appointmentsTypesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof appointmentsTypesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsTypesRetrieve<TData = Awaited<ReturnType<typeof appointmentsTypesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof appointmentsTypesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsTypesRetrieve<TData = Awaited<ReturnType<typeof appointmentsTypesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAppointmentsTypesRetrieve<TData = Awaited<ReturnType<typeof appointmentsTypesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppointmentsTypesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type appointmentsTypesUpdateResponse200 = {
  data: AppointmentType
  status: 200
}
    
export type appointmentsTypesUpdateResponseSuccess = (appointmentsTypesUpdateResponse200) & {
  headers: Headers;
};
;

export type appointmentsTypesUpdateResponse = (appointmentsTypesUpdateResponseSuccess)

export const getAppointmentsTypesUpdateUrl = (id: string,) => {


  

  return `/api/v1/appointments/types/${id}/`
}

export const appointmentsTypesUpdate = async (id: string,
    appointmentTypeRequest: AppointmentTypeRequest, options?: RequestInit): Promise<appointmentsTypesUpdateResponse> => {
  
  return apiFetch<appointmentsTypesUpdateResponse>(getAppointmentsTypesUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appointmentTypeRequest,)
  }
);}




export const getAppointmentsTypesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsTypesUpdate>>, TError,{id: string;data: AppointmentTypeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsTypesUpdate>>, TError,{id: string;data: AppointmentTypeRequest}, TContext> => {

const mutationKey = ['appointmentsTypesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsTypesUpdate>>, {id: string;data: AppointmentTypeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  appointmentsTypesUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsTypesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsTypesUpdate>>>
    export type AppointmentsTypesUpdateMutationBody = AppointmentTypeRequest
    export type AppointmentsTypesUpdateMutationError = unknown

    export const useAppointmentsTypesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsTypesUpdate>>, TError,{id: string;data: AppointmentTypeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsTypesUpdate>>,
        TError,
        {id: string;data: AppointmentTypeRequest},
        TContext
      > => {

      const mutationOptions = getAppointmentsTypesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type appointmentsTypesPartialUpdateResponse200 = {
  data: AppointmentType
  status: 200
}
    
export type appointmentsTypesPartialUpdateResponseSuccess = (appointmentsTypesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type appointmentsTypesPartialUpdateResponse = (appointmentsTypesPartialUpdateResponseSuccess)

export const getAppointmentsTypesPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/appointments/types/${id}/`
}

export const appointmentsTypesPartialUpdate = async (id: string,
    patchedAppointmentTypeRequest: PatchedAppointmentTypeRequest, options?: RequestInit): Promise<appointmentsTypesPartialUpdateResponse> => {
  
  return apiFetch<appointmentsTypesPartialUpdateResponse>(getAppointmentsTypesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedAppointmentTypeRequest,)
  }
);}




export const getAppointmentsTypesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsTypesPartialUpdate>>, TError,{id: string;data: PatchedAppointmentTypeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsTypesPartialUpdate>>, TError,{id: string;data: PatchedAppointmentTypeRequest}, TContext> => {

const mutationKey = ['appointmentsTypesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsTypesPartialUpdate>>, {id: string;data: PatchedAppointmentTypeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  appointmentsTypesPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsTypesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsTypesPartialUpdate>>>
    export type AppointmentsTypesPartialUpdateMutationBody = PatchedAppointmentTypeRequest
    export type AppointmentsTypesPartialUpdateMutationError = unknown

    export const useAppointmentsTypesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsTypesPartialUpdate>>, TError,{id: string;data: PatchedAppointmentTypeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsTypesPartialUpdate>>,
        TError,
        {id: string;data: PatchedAppointmentTypeRequest},
        TContext
      > => {

      const mutationOptions = getAppointmentsTypesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type appointmentsTypesDestroyResponse204 = {
  data: void
  status: 204
}
    
export type appointmentsTypesDestroyResponseSuccess = (appointmentsTypesDestroyResponse204) & {
  headers: Headers;
};
;

export type appointmentsTypesDestroyResponse = (appointmentsTypesDestroyResponseSuccess)

export const getAppointmentsTypesDestroyUrl = (id: string,) => {


  

  return `/api/v1/appointments/types/${id}/`
}

export const appointmentsTypesDestroy = async (id: string, options?: RequestInit): Promise<appointmentsTypesDestroyResponse> => {
  
  return apiFetch<appointmentsTypesDestroyResponse>(getAppointmentsTypesDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getAppointmentsTypesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsTypesDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof appointmentsTypesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['appointmentsTypesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appointmentsTypesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  appointmentsTypesDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AppointmentsTypesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof appointmentsTypesDestroy>>>
    
    export type AppointmentsTypesDestroyMutationError = unknown

    export const useAppointmentsTypesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appointmentsTypesDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appointmentsTypesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAppointmentsTypesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type appointmentsTypesSlotsListResponse200 = {
  data: Slot[]
  status: 200
}
    
export type appointmentsTypesSlotsListResponseSuccess = (appointmentsTypesSlotsListResponse200) & {
  headers: Headers;
};
;

export type appointmentsTypesSlotsListResponse = (appointmentsTypesSlotsListResponseSuccess)

export const getAppointmentsTypesSlotsListUrl = (id: string,
    params?: AppointmentsTypesSlotsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/appointments/types/${id}/slots/?${stringifiedParams}` : `/api/v1/appointments/types/${id}/slots/`
}

export const appointmentsTypesSlotsList = async (id: string,
    params?: AppointmentsTypesSlotsListParams, options?: RequestInit): Promise<appointmentsTypesSlotsListResponse> => {
  
  return apiFetch<appointmentsTypesSlotsListResponse>(getAppointmentsTypesSlotsListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAppointmentsTypesSlotsListQueryKey = (id?: string,
    params?: AppointmentsTypesSlotsListParams,) => {
    return [
    `/api/v1/appointments/types/${id}/slots/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAppointmentsTypesSlotsListQueryOptions = <TData = Awaited<ReturnType<typeof appointmentsTypesSlotsList>>, TError = unknown>(id: string,
    params?: AppointmentsTypesSlotsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesSlotsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppointmentsTypesSlotsListQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appointmentsTypesSlotsList>>> = ({ signal }) => appointmentsTypesSlotsList(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesSlotsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppointmentsTypesSlotsListQueryResult = NonNullable<Awaited<ReturnType<typeof appointmentsTypesSlotsList>>>
export type AppointmentsTypesSlotsListQueryError = unknown


export function useAppointmentsTypesSlotsList<TData = Awaited<ReturnType<typeof appointmentsTypesSlotsList>>, TError = unknown>(
 id: string,
    params: undefined |  AppointmentsTypesSlotsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesSlotsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsTypesSlotsList>>,
          TError,
          Awaited<ReturnType<typeof appointmentsTypesSlotsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsTypesSlotsList<TData = Awaited<ReturnType<typeof appointmentsTypesSlotsList>>, TError = unknown>(
 id: string,
    params?: AppointmentsTypesSlotsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesSlotsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appointmentsTypesSlotsList>>,
          TError,
          Awaited<ReturnType<typeof appointmentsTypesSlotsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppointmentsTypesSlotsList<TData = Awaited<ReturnType<typeof appointmentsTypesSlotsList>>, TError = unknown>(
 id: string,
    params?: AppointmentsTypesSlotsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesSlotsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAppointmentsTypesSlotsList<TData = Awaited<ReturnType<typeof appointmentsTypesSlotsList>>, TError = unknown>(
 id: string,
    params?: AppointmentsTypesSlotsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appointmentsTypesSlotsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppointmentsTypesSlotsListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




